import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { CopyToClipboard } from "react-copy-to-clipboard";
import copyicon from "../../public/assets/copy-icon.svg"

function CopyClipBoard({value}) {
    const [isCopied, setCopied] = useState(false);
  
    // useEffect(() => {
    //   const timeout = setTimeout(() => {
    //     setCopied(false);
    //   }, 3000);
  
    //   return () => clearTimeout(timeout);
    // }, [isCopied]);
  
    return (
        <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
            <img src={copyicon} alt="" style={{height: "16px", width: "16px", marginLeft: "5px", cursor: "pointer"}}></img>
          {/* <Button style={{marginLeft: "10px", fontSize: "12px"}}>Copy</Button> */}
        </CopyToClipboard>
    );
}

export default CopyClipBoard